import api from '../../plugins/api'

export enum StatusAprovacao {
    PENDENTE = 'Pendente',
    NAO_APLICADO = 'Não aplicado'
}

export type Livro = {
    id: string
    link: string
    CodLivroDigital: number
    IdDocsprime: number
    ano: number
    mes: number
    statusAprovacao: StatusAprovacao
}

export const loadLivros = async (codigo_condominio: number): Promise<Livro[]> => {
    const { data } = await api.get<Livro[]>(`/condominios/${codigo_condominio}/livro-digital`);
    return data
}